import * as Yup from "yup";


export const StudyUploadSchema = Yup.object({
  patientName: Yup.string()
    .min(3, "Patient name must be at least 3 characters")
    .max(100, "Patient name must be 100 characters or less")
    .matches(/^[^<>]*$/, "Patient name cannot contain HTML tags")
    .matches(/^[^=+\-@].*$/, "Patient name cannot start with =, +, - or @")
    .required("Patient name cannot be blank"),

  age: Yup.string()
    .matches(/(^[0-9]{1,3}[DWMYdwmy]$)|(^[0-9]{1,3}$)/, "Patient age is not valid"),

  patientId: Yup.string()
    .min(1, "Patient id must be at least 1 characters")
    .max(50, "Patient id must be 50 characters or less")
    .matches(/^[^<>]*$/, "Patient id cannot contain HTML tags")
    .matches(/^[^=+\-@].*$/, "Patient id cannot start with =, +, - or @")
    .required("Patient id cannot be blank"),

  accessionNumber: Yup.string()
    .max(255, "Accession number must be 255 characters or less")
    .matches(/^[^<>]*$/, "Accession number cannot contain HTML tags")
    .matches(/^[^=+\-@].*$/, "Accession number cannot start with =, +, - or @"),
});

